module.exports = __webpack_public_path__ + "static/media/logotipo.7832b1fe.svg";